

















































































import {Component, Ref} from "vue-property-decorator"
import Vue from "vue"

import JdiContent from "@/components/JdiContent.vue"
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdsActionBox from "@/design-system/patterns/JdsActionBox.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdsSheet from "../../../design-system/patterns/Sheet/JdsSheet.vue"
import SheetExampleInterim from "@/content/6-patterns/Sheet/SheetExampleInterim.vue"
import JdsInspector from "@/design-system/patterns/Inspector/JdsInspector.vue"

@Component({
    components: {SheetExampleInterim, JdsSheet}
})
export default class SheetExample extends Vue {
    @Ref() inspector!: JdsInspector;
    openInspector () {
        this.inspector.open().catch(()=>{});
    }
}
